var _circle, _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendButtonText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.3974,
    cy: 29.3974,
    r: 29.3974,
    fill: "url(#paint0_linear_2126_5342)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27.6681,
    height: 27.6681,
    transform: "translate(18.1562 15.5625)",
    fill: "url(#paint1_linear_2126_5342)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.193 17.4983C20.3221 17.3887 20.4806 17.3195 20.6488 17.2992C20.817 17.2789 20.9874 17.3085 21.1389 17.3842L43.6192 28.6243C43.7627 28.6962 43.8833 28.8066 43.9675 28.9431C44.0518 29.0796 44.0965 29.2369 44.0965 29.3973C44.0965 29.5578 44.0518 29.715 43.9675 29.8515C43.8833 29.988 43.7627 30.0984 43.6192 30.1703L21.1389 41.4105C20.9875 41.4864 20.8171 41.5162 20.6489 41.4961C20.4807 41.476 20.3221 41.407 20.1928 41.2976C20.0635 41.1882 19.9692 41.0432 19.9216 40.8807C19.874 40.7181 19.8751 40.5452 19.925 40.3833L23.3056 29.3973L19.925 18.4114C19.8754 18.2496 19.8744 18.0769 19.9221 17.9146C19.9697 17.7523 20.0639 17.6076 20.193 17.4983ZM24.8481 30.262L22.173 38.9601L41.2986 29.3973L22.173 19.8345L24.8481 28.5327H34.5856C34.8149 28.5327 35.0348 28.6238 35.197 28.7859C35.3591 28.9481 35.4502 29.168 35.4502 29.3973C35.4502 29.6266 35.3591 29.8466 35.197 30.0087C35.0348 30.1709 34.8149 30.262 34.5856 30.262H24.8481Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2126_5342",
    x1: 29.3974,
    y1: 0,
    x2: 29.3974,
    y2: 58.7948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#014A99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2126_5342",
    x1: 13.8341,
    y1: 0,
    x2: 13.8341,
    y2: 27.6681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendButtonText);
export default __webpack_public_path__ + "static/media/send-button-text.a5c93bfdc21f95ebb8727d9110891129.svg";
export { ForwardRef as ReactComponent };